import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-arda',
  templateUrl: './why-arda.component.html',
  styleUrls: ['./why-arda.component.scss']
})
export class WhyArdaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/rafaelneves/code/ads/ardaexperience/src/app/pages/why-arda/why-arda.component.ts